var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"50px"}},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h3',[_vm._v("Sorry, page not found.")]),_vm._v(" "),_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"50px"}},[_vm._v("sentiment_very_dissatisfied")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565212e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = null
// module chunks = 